export default __webpack_public_path__ + "static/Theinhardt-Heavy-Italic-subset-d734a2ca786f385f5ac6948add537dea.woff";